import React, { useEffect, useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { testUrl } from "../BaseData";
import classes from "../activities/Activities.module.css";
import styles from "./OquvRejaVaDasturlar.module.css";
import { FaGraduationCap, FaBookOpen } from "react-icons/fa";

const OquvRejaVaDasturlar = () => {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const [bachelors, setBachelors] = useState([]);
    const [masters, setMasters] = useState([]);
    const [loading, setLoading] = useState(true);
    const [activitiesTypes, setActivitiesTypes] = useState([]);
    const [category, setCategory] = useState(null);
    const currentLang = i18n.language;

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                // Fetch directions
                const [bachelorsRes, mastersRes, sidebarRes] = await Promise.all([
                    axios.get(testUrl + "/api/directions/bachelors/"),
                    axios.get(testUrl + "/api/directions/masters/"),
                    axios.get(testUrl + `/api/baseactivity/oquv-faoliyat/oquv-jarayoni`) // Use oquv-jarayoni to get the oquv-faoliyat sidebar
                ]);

                setBachelors(Array.isArray(bachelorsRes.data) ? bachelorsRes.data : bachelorsRes.data?.results || []);
                setMasters(Array.isArray(mastersRes.data) ? mastersRes.data : mastersRes.data?.results || []);

                if (sidebarRes.data) {
                    setCategory(sidebarRes.data.category);
                    setActivitiesTypes(sidebarRes.data.activities_types || []);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [i18n.language]);

    const getDirectionName = (direction) => {
        const name = direction[`name_${i18n.language}`];
        return name || direction.name_uz || t("no_name_available");
    };

    if (loading) {
        return <div className={styles.loader}>{t("loading...")}</div>;
    }

    const short_name = "oquv-reja-va-dasturlar";

    return (
        <div className={classes.mainContainer}>
            <div data-aos="fade-up" className={classes.container}>
                <h1 className={classes["page-title"]}>{t("oquv_reja_va_dasturlar")}</h1>

                <section className={styles.section}>
                    <div className={styles.sectionHeader}>
                        <FaGraduationCap className={styles.sectionIcon} />
                        <h2>{t("bakalavr_yonalishlari")}</h2>
                    </div>
                    <div className={styles.cardGrid}>
                        {bachelors.map((item) => (
                            <Link
                                key={item.id}
                                to={`/oquv-dasturi/${item.short_name}`}
                                className={styles.titleCard}
                            >
                                <h3>{getDirectionName(item)}</h3>
                            </Link>
                        ))}
                    </div>
                </section>

                <section className={styles.section}>
                    <div className={styles.sectionHeader}>
                        <FaBookOpen className={styles.sectionIcon} />
                        <h2>{t("magistratura_yonalishlari")}</h2>
                    </div>
                    <div className={styles.cardGrid}>
                        {masters.map((item) => (
                            <Link
                                key={item.id}
                                to={`/oquv-dasturi/${item.short_name}`}
                                className={styles.titleCard}
                            >
                                <h3>{getDirectionName(item)}</h3>
                            </Link>
                        ))}
                    </div>
                </section>
            </div>

            <div className={classes.sidebar}>
                <h3>
                    {category ? category[`name_${i18n.language}`] : "O'quv faoliyat"}
                </h3>
                <ul>
                    {activitiesTypes.map((cat) => (
                        <li
                            key={cat.id}
                            className={cat.short_name === short_name ? classes.active : ''}
                            onClick={() => navigate(`/activity/${category.short_name}/${cat.short_name}`)}
                        >
                            {cat[`name_${currentLang}`]}
                        </li>
                    ))}
                    {/* Manually add the current page to the sidebar if it's not there */}
                    {!activitiesTypes.some(cat => cat.short_name === short_name) && (
                        <li
                            className={classes.active}
                            onClick={() => navigate(`/activity/oquv-faoliyat/oquv-reja-va-dasturlar`)}
                        >
                            {t("oquv_reja_va_dasturlar")}
                        </li>
                    )}
                </ul>
            </div>
        </div>
    );
};

export default OquvRejaVaDasturlar;
